(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-tgh-plans]').forEach(function (scroller) {
      if (scroller.dataset.tghReady) return;
      scroller.dataset.tghReady = '1';

      var card = scroller.closest('.tgh-plans__card') || scroller.parentElement;
      var raf = 0;

      function update() {
        raf = 0;
        var max = scroller.scrollWidth - scroller.clientWidth;
        scroller.classList.toggle('is-scrolled', scroller.scrollLeft > 1);
        card.classList.toggle('has-more', max > 1 && scroller.scrollLeft < max - 1);
      }

      function schedule() { if (!raf) raf = requestAnimationFrame(update); }

      scroller.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(scroller);
      update();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();



// WEBPACK FOOTER //
// ./assets/js/modules/plans-table.js